import { useManagerStateMatchesAllOf } from '../xstate/app.xstate';

export const useLoadingState = () => {
  const isFullyLoaded = useManagerStateMatchesAllOf([
    'orgRelated.ready.projectsNew.loaded',
  ]);

  return !isFullyLoaded;
};
